import React from 'react';
import { useTranslation } from '@shared/core';
import { Badges } from './Badges';
import type { BadgesFromFlagsProps, HotelTileBadgeItem } from '../HotelTile.types';

export const BadgesFromFlags: React.FC<BadgesFromFlagsProps> = React.memo(({ isFavorite, isHostStayingHere, hasRoomBlock, roomCount }) => {
  const { tq } = useTranslation('sharedComponents');

  const items: HotelTileBadgeItem[] = [];
  if (isFavorite) items.push({ label: tq`Our Pick` });
  if (isHostStayingHere) items.push({ label: tq`We're staying here` });
  if (hasRoomBlock) {
    items.push({ label: tq`Room block` });
    if (roomCount != null && roomCount > 0) {
      items.push({ label: roomCount === 1 ? tq`${roomCount} room` : tq`${roomCount} rooms` });
    }
  }

  return <Badges items={items} />;
});

BadgesFromFlags.displayName = 'HotelTile.BadgesFromFlags';
